import BaseState from '@state/BaseState'
import { Signals} from "@/Imports";
import GameStatesEnum from "@/states/GameStatesEnum";

export default class IdleState extends BaseState {

  begin() {
    Signals.socketClosed.add(this.onSocketClosed, this)
    Signals.forceMakeBets.add(this.onForceMakeBets, this)
    Signals.forceRoundStart.add(this.onForceRoundStart, this)


  }

  onForceMakeBets() {
    this.gameState = GameStatesEnum.MAKE_BETS
    this.end()
  }

  onForceRoundStart() {
    this.gameState = GameStatesEnum.ROUND_START

    this.end()
  }

  onSocketClosed() {
    this.gameState = GameStatesEnum.RECONNECT_SOCKET
    this.end()
  }

  end = () => {
    this.stateMachine.setState(this.gameState)
  }

  cleanUp() {
    Signals.socketClosed.remove(this.onForceRoundStart, this)
    Signals.forceMakeBets.remove(this.onForceMakeBets, this)
    Signals.forceRoundStart.remove(this.onForceRoundStart, this)
  }
}
